import 'whatwg-fetch';


export const downloadSchedule = () => (
  (dispatch) => {
    fetch('/api/schedule.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          const sections = json.eventBranchViews.map(section => {
            const scheduleViewList = json.scheduleView.roomEvents.filter(element => {
              return element.roomEventShortView.eventBranchId == section.id
            });
            const roomId = json.scheduleView.roomEvents.filter(element => {
              return element.roomEventShortView.eventBranchId === section.id &&
                  element.type === 'Open'
            })[0].roomId;
            const roomName = json.scheduleView.rooms.filter(element => {
              return element.id === roomId;
            })[0].roomName;

            const roomDate = scheduleViewList[0].eventDay;
            return {...section, scheduleViewList: scheduleViewList, roomName: roomName, roomDate: roomDate};
          });
          dispatch({
            type: 'PARSE_SHEDULE_LIST',
            sections: sections
          })
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'SCHEDULE_ERROR',
          error: err,
        })
      })
  }
);
export const downloadScheduleRoom = (room) => (
  (dispatch) => {
    fetch(`/api/room-event-object/${room.id}.json`)
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'PARSE_SHEDULE_ROOM',
            roomEventView: json.roomEventView
          })
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'SCHEDULE_ERROR',
          error: err,
        })
      })
  }
);



// WEBPACK FOOTER //
// ./src/schedule-page/actions.js